<template>
  <section>
    <div class="text-center mb-8 text-static-ai-hi">
      <IconSparklesFilled class="inline" size="12" />
      <span id="ai-reco-prompt-suggestions-title" class="caption ml-2">
        {{ i18n(translations.promptSuggestionsTitle) }}
      </span>
    </div>

    <ul
      aria-labelledby="ai-reco-prompt-suggestions-title"
      class="flex flex-col gap-12 bg-static-ai-mid rounded-[22px] p-12 items-end"
    >
      <li v-for="(suggestion, index) in suggestions" :key="index">
        <Suggestion :suggestion @click="$emit('click', suggestion)" />
      </li>
    </ul>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconSparklesFilled } from '@ds/icons/IconSparklesFilled'

import translations from '../ShoppingAssistant.translations'

import Suggestion from './Suggestion.vue'

defineProps<{ suggestions: string[] }>()

defineEmits<{ click: [suggestion: string] }>()

const i18n = useI18n()
</script>
